/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/* =========================================================================
 * MAG Lieferdatum-Rechner (CVR)
 * Cutoff 14 Uhr Europe/Berlin. Bestellung vor 14 Uhr an einem Werktag =
 * Versand heute, sonst nächster Werktag. Lieferung = Versand + min..max Werktage.
 * Ersetzt den Text in .mag-delivery-eta (Fallback bleibt bei deaktiviertem JS).
 * Hinweis: rechnet Wochenenden raus, keine Feiertage.
 * ========================================================================= */
(function () {
  var MONTHS = ['Jan', 'Feb', 'März', 'Apr', 'Mai', 'Juni', 'Juli', 'Aug', 'Sept', 'Okt', 'Nov', 'Dez'];
  var WEEKDAYS = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

  // Bundesweite DE-Feiertage (fix + Ostern-basiert), pro Jahr gecacht
  var _holidayCache = {};
  function easterSunday(year) {
    var a = year % 19, b = Math.floor(year / 100), c = year % 100,
        d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
        g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
        i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7,
        m = Math.floor((a + 11 * h + 22 * l) / 451),
        month = Math.floor((h + l - 7 * m + 114) / 31),
        day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  }
  function holidaySet(year) {
    if (_holidayCache[year]) return _holidayCache[year];
    var s = {};
    function add(dt) { s[dt.getMonth() + 1 + '-' + dt.getDate()] = true; }
    add(new Date(year, 0, 1));    // Neujahr
    add(new Date(year, 4, 1));    // Tag der Arbeit
    add(new Date(year, 9, 3));    // Tag der Deutschen Einheit
    add(new Date(year, 11, 25));  // 1. Weihnachtstag
    add(new Date(year, 11, 26));  // 2. Weihnachtstag
    var easter = easterSunday(year);
    function rel(days) { var dt = new Date(easter.getTime()); dt.setDate(dt.getDate() + days); return dt; }
    add(rel(-2));  // Karfreitag
    add(rel(1));   // Ostermontag
    add(rel(39));  // Christi Himmelfahrt
    add(rel(50));  // Pfingstmontag
    _holidayCache[year] = s;
    return s;
  }
  function isHoliday(date) {
    return !!holidaySet(date.getFullYear())[(date.getMonth() + 1) + '-' + date.getDate()];
  }

  function isBusinessDay(date) {
    var d = date.getDay();
    return d !== 0 && d !== 6 && !isHoliday(date);
  }

  function addBusinessDays(date, count) {
    var result = new Date(date.getTime());
    var added = 0;
    while (added < count) {
      result.setDate(result.getDate() + 1);
      if (isBusinessDay(result)) {
        added += 1;
      }
    }
    return result;
  }

  function nextBusinessDay(date) {
    var result = new Date(date.getTime());
    do {
      result.setDate(result.getDate() + 1);
    } while (!isBusinessDay(result));
    return result;
  }

  function berlinParts() {
    var fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Berlin',
      year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hour12: false
    });
    var parts = {};
    fmt.formatToParts(new Date()).forEach(function (p) {
      if (p.type !== 'literal') parts[p.type] = parseInt(p.value, 10);
    });
    return parts;
  }

  function formatDate(date) {
    return WEEKDAYS[date.getDay()] + ', ' + date.getDate() + '. ' + MONTHS[date.getMonth()];
  }

  function computeEta(minDays, maxDays, cutoffHour) {
    var p = berlinParts();
    // Berlin-Kalendertag als lokales Date (nur Datums-Arithmetik, Uhrzeit separat geprüft)
    var ship = new Date(p.year, p.month - 1, p.day);
    var shipsToday = isBusinessDay(ship) && p.hour < cutoffHour;
    if (!shipsToday) {
      ship = nextBusinessDay(ship);
    }
    var min = addBusinessDays(ship, minDays);
    var max = addBusinessDays(ship, maxDays);
    var range = min.getTime() === max.getTime()
      ? formatDate(min)
      : formatDate(min) + ' – ' + formatDate(max);
    return { range: range, shipsToday: shipsToday };
  }

  function render() {
    var nodes = document.querySelectorAll('.mag-delivery-eta');
    if (!nodes.length) return;
    nodes.forEach(function (node) {
      var minDays = parseInt(node.getAttribute('data-eta-min'), 10) || 1;
      var maxDays = parseInt(node.getAttribute('data-eta-max'), 10) || 2;
      var cutoffHour = parseInt(node.getAttribute('data-eta-cutoff'), 10) || 14;
      try {
        var eta = computeEta(minDays, maxDays, cutoffHour);
        var prefix = eta.shipsToday ? 'Bestell bis 14 Uhr → Lieferung ' : 'Lieferung ';
        node.innerHTML = prefix + '<b>' + eta.range + '</b>';
      } catch (e) {
        /* Fallback-Text bleibt unverändert */
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();

/* =========================================================================
 * MAG Farbwähler-Sync (CVR)
 * Hält Swatches (Radios) und Namens-Dropdown synchron + Aufklapp-Toggle.
 * Custom-Element: connectedCallback läuft auch nach Section-Re-Render erneut.
 * ========================================================================= */
(function () {
  if (window.customElements && customElements.get('color-picker-sync')) return;

  class ColorPickerSync extends HTMLElement {
    connectedCallback() {
      this._select = this.querySelector('[data-color-select]');
      this._list = this.querySelector('[data-color-list]');
      this._toggle = this.querySelector('[data-color-toggle]');

      if (this._select && !this._select._magBound) {
        this._select._magBound = true;
        this._select.addEventListener('change', this._onSelect.bind(this));
      }
      if (this._list && !this._list._magBound) {
        this._list._magBound = true;
        this._list.addEventListener('change', this._onSwatch.bind(this));
      }
      if (this._toggle && !this._toggle._magBound) {
        this._toggle._magBound = true;
        this._toggle.addEventListener('click', this._onToggle.bind(this));
      }
    }

    _onSelect() {
      var opt = this._select.options[this._select.selectedIndex];
      if (!opt) return;
      var href = opt.getAttribute('data-href');
      if (href) { window.location.href = href; return; }
      var radioId = opt.getAttribute('data-radio');
      if (!radioId) return;
      var radio = document.getElementById(radioId);
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    _onSwatch(e) {
      var radio = e.target;
      if (!radio || radio.type !== 'radio' || !this._select) return;
      if (this._select.value !== radio.value) this._select.value = radio.value;
    }

    _onToggle() {
      if (!this._list) return;
      var expanded = this._list.classList.toggle('is-expanded');
      this._toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  }

  if (window.customElements) customElements.define('color-picker-sync', ColorPickerSync);
})();

/* =========================================================================
 * MAG Gratis-Versand-Nudge (CVR)
 * Zeigt Restbetrag bis zur Versandkosten-Schwelle, aktualisiert mit Menge.
 * Custom-Element: connectedCallback läuft auch nach Section-Re-Render erneut.
 * ========================================================================= */
(function () {
  if (window.customElements && customElements.get('mag-freeship')) return;

  class MagFreeship extends HTMLElement {
    connectedCallback() {
      this._threshold = parseInt(this.getAttribute('data-threshold'), 10) || 5000;
      this._cart = parseInt(this.getAttribute('data-cart'), 10) || 0;
      this._textEl = this.querySelector('[data-freeship-text]');
      this._fillEl = this.querySelector('[data-freeship-fill]');
      // Auf Warenkorb-Änderungen reagieren (Focal feuert cart:updated/cart:refresh auf documentElement, bubbelt zu document)
      this._onCart = this._onCart.bind(this);
      document.addEventListener('cart:updated', this._onCart);
      document.addEventListener('cart:refresh', this._onCart);
      // data-cart ist serverseitig gerendert (und nach jedem Section-Re-Render frisch) — kein Fetch beim Connect nötig.
      this._update();
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this._onCart);
      document.removeEventListener('cart:refresh', this._onCart);
    }

    _onCart(e) {
      var cart = e && e.detail && e.detail.cart;
      if (cart && typeof cart.total_price === 'number') {
        this._cart = cart.total_price;
        this._update();
      } else {
        this._refreshCart();
      }
    }

    _refreshCart() {
      var self = this;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          if (c && typeof c.total_price === 'number') {
            self._cart = c.total_price;
            self._update();
          }
        })
        .catch(function () { /* Render-Wert bleibt */ });
    }

    _money(cents) {
      try {
        return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
      } catch (e) {
        return (cents / 100).toFixed(2).replace('.', ',') + ' €';
      }
    }

    _update() {
      var remaining = this._threshold - this._cart;
      var pct = Math.max(0, Math.min(100, Math.round((this._cart / this._threshold) * 100)));
      if (this._fillEl) this._fillEl.style.width = pct + '%';
      if (!this._textEl) return;
      if (remaining <= 0) {
        this._textEl.innerHTML = '<b>Gratis-Versand</b> – versandkostenfrei!';
        this.classList.add('is-reached');
      } else {
        this._textEl.innerHTML = 'Noch <b>' + this._money(remaining) + '</b> bis zum Gratis-Versand';
        this.classList.remove('is-reached');
      }
    }
  }

  if (window.customElements) customElements.define('mag-freeship', MagFreeship);
})();